import tagTester from './_tagTester.js';

export default tagTester('ArrayBuffer');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isArrayBuffer.js
// module id = 485
// module chunks = 0